import {
  REMOVE_WORKER,
  REMOVE_SHOP,
  LOAD_SHOPS,
  LOAD_WORKERS_BY_SHOP,
  LOAD_UNASSIGNED_WORKERS,
  LOAD_SHOP_LEADS,
  LOAD_SHOP,
  ADD_SHOP,
  UPDATE_SHOP,
  CHECK_SHOP_UNIQUE
} from '../../actions/shops';

export default function shops(state = {}, action) {
  switch(action.type) {
    case REMOVE_WORKER:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case REMOVE_SHOP:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case LOAD_SHOPS:
      return Object.assign({}, state, action.payload);
    case LOAD_WORKERS_BY_SHOP:
      return Object.assign({}, state, action.payload);
    case LOAD_UNASSIGNED_WORKERS:
      return Object.assign({}, state, action.payload);
    case LOAD_SHOP_LEADS:
      return Object.assign({}, state, action.payload);
    case LOAD_SHOP:
      return Object.assign({}, state, action.payload);
    case ADD_SHOP:
      return Object.assign({}, state, action.payload);
    case UPDATE_SHOP:
      return Object.assign({}, state, action.payload);
    case CHECK_SHOP_UNIQUE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shops/index.js